import styled from '@emotion/styled';
import ReactTooltip from 'react-tooltip';
import { css } from '@emotion/react';
import { colors } from 'ui_system/compass/utils';
import { t } from 'services/translation';

const AffiliatePaymentSelectorWrapper = styled.div`
  display: flex;
  font-size: 16px;
  text-align: center;
  margin-top: 12px;
  margin-bottom: 24px;
`;

const PaymentButtonWrapper = styled.span<PaymentButtonWrapperProps>`
  display: flex;
  width: 50%;
  ${({ disabledStyle }) =>
    disabledStyle &&
    css`
      cursor: not-allowed !important;
    `}
`;

const PaymentButton = styled.button<PaymentButtonProps>`
  flex-grow: 1;
  flex-basis: 0;
  padding: 10px 5px;
  background: ${colors.white};
  border: 1px solid ${colors.primary};
  color: ${colors.primary};
  cursor: pointer;
  ${({ active }) =>
    active &&
    css`
      background: ${colors.primary};
      color: ${colors.white};
    `}
  ${({ disabledStyle }) =>
    disabledStyle &&
    css`
      opacity: 0.3;
      cursor: not-allowed;
    `}
`;

const ToolTipLabel = styled.span`
  text-align: left;
  display: block;
  width: 140px;
  word-wrap: break-word;
`;

type AffiliatePaymentSelectorProps = {
  paymentType: string;
  disabledOptions: any;
  paymentTypeChanged: any;
};

type PaymentButtonWrapperProps = {
  disabledStyle: boolean;
};

type PaymentButtonProps = {
  active: boolean;
  disabledStyle: boolean;
};

const buttonConfig: any = {
  'charge-card': {
    title: 'Credit Card',
    dataTestId: 'affiliate-credit-card',
  },
  'pay-later': {
    title: 'Pay Later',
    dataTestId: 'affiliate-pay-later',
  },
};

const AffiliatePaymentSelector = ({
  paymentTypeChanged,
  paymentType,
  disabledOptions,
}: AffiliatePaymentSelectorProps) => {
  const buttonChanged = (event: any) => {
    paymentTypeChanged(event.target.value);
  };

  return (
    <AffiliatePaymentSelectorWrapper>
      {Object.keys(buttonConfig).map((key) => {
        const shouldDisable = disabledOptions.includes(key);
        const active = paymentType === key;
        const className = active ? 'brand-bg brand-border' : 'brand-color';
        return (
          <PaymentButtonWrapper disabledStyle={shouldDisable}>
            <PaymentButton
              id={key}
              data-tip
              data-for={shouldDisable ? 'disabled-button' : undefined}
              active={active}
              disabledStyle={shouldDisable}
              className={className}
              aria-disabled={shouldDisable}
              type="button"
              {...(!shouldDisable && { onClick: buttonChanged })}
              value={key}
            >
              {buttonConfig[key].title}
            </PaymentButton>
            <ReactTooltip
              id="disabled-button"
              type="light"
              textColor={colors.text.primary}
              backgroundColor={colors.white}
              border
              borderColor={colors.border}
            >
              <ToolTipLabel>{t('PAY_LATER_DISABLED')}</ToolTipLabel>
            </ReactTooltip>
          </PaymentButtonWrapper>
        );
      })}
    </AffiliatePaymentSelectorWrapper>
  );
};

export default AffiliatePaymentSelector;
